import { DialogTitle, Grid, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import ResponsiveDialogAction from 'app/components/dialog/ResponsiveDialogAction'
import ResponsiveDialogContent from 'app/components/dialog/ResponsiveDialogContent'

function TransferSuccessDialog(props) {
  const { isOpen, onClose, loading, teamMemberName } = props

  return (
    <ResponsiveDialog
      open={isOpen}
      onClose={onClose}
      scroll="paper"
      fullWidth
      maxWidth="xs"
      aria-labelledby="scroll-dialog-title"
      isFullScreen={false}
    >
      <DialogTitle className="pb-4 mt-8">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormattedMessage id="transfer.declined.title" />
          </Grid>
        </Grid>
      </DialogTitle>
      <ResponsiveDialogContent>
        <Typography>
          <FormattedMessage
            id="transfer.declined.content"
            values={{ teamMemberName }}
          />
        </Typography>
      </ResponsiveDialogContent>
      <ResponsiveDialogAction
        EndButton={
          <PrimaryButton
            labelId={'action.ok'}
            onClick={onClose}
            className="w-full"
            isLoading={loading}
          />
        }
      />
    </ResponsiveDialog>
  )
}

TransferSuccessDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default TransferSuccessDialog
